import React from 'react';
import Image from 'next/image';
import { Stack, Typography, Button, useTheme, useMediaQuery, styled } from '@mui/material';
import { Box } from '@mui/system';

const BackgroundStack = styled(Stack)`
  background-color: #5FA3A9;
  background-image: repeating-linear-gradient(
    45deg,
    transparent,
    transparent 16px,
    #67ACB2 16px,
    #67ACB2 40px
  );
`;

const ContentStack = styled(Stack)`
  box-shadow: 8px 10px 16px rgba(0, 0, 0, 0.15);

  ${({ theme }) => theme.breakpoints.down('lg')} {
    box-shadow: none;
  }
`;

function OneVillageMediaKit() {
  const theme = useTheme();
  const matchesMdUp = useMediaQuery(`${theme.breakpoints.up('md')}`);

  return (
    <BackgroundStack
      sx={{
        paddingY: { xs: 0, sm: theme.spacing(14.5) },
        alignItems: 'center',
      }}
    >
      <ContentStack
        sx={{
          height:{ xs: 'auto', md: theme.spacing(56.5) },
          borderRadius: { xs: 0, sm: theme.spacing(2) },
          maxWidth: { xs: '100%', md: '707px' },
          flexDirection: { xs: 'column', md: 'row' },
          overflow: 'hidden'
        }}
      >
        <Box
          sx={
            matchesMdUp
              ? {
                  width: theme.spacing(56.5),
                  height: theme.spacing(56.5),
                  position: 'relative',
                }
              : {
                  position: 'relative',
                  width: '100%',
                  paddingTop: 'calc(1 / 1 * 100%)',
                }
          }
        >
          <Image
            src="/images/press-center/onevillage-media-kit.png"
            layout="fill"
            objectFit="cover"
            objectPosition="center"
          />
        </Box>

        <Stack
          sx={{
            gap: theme.spacing(5.5),
            padding: theme.spacing(6, 8, 7.5),
            backgroundColor: '#D5ECEC',
          }}
        >
          <Stack
            sx={{
              gap: theme.spacing(2),
              paddingX: theme.spacing(1.5),
            }}
          >
            <Typography
              variant="h2"
              color="#52545F"
              sx={{
                fontSize: {xs: '1.4375rem !important', md: '2.375rem !important' },
                lineHeight: { xs: '1.4 !important', md: '1.2 !important'},
                textAlign: { xs: 'center', md: 'start' },
              }}
            >
              OneVillage Media Kit
            </Typography>

            <Typography
              fontSize="1.125rem !important"
              lineHeight="1.46 !important"
              variant="body2"
              color="#52545F"
              sx={{
                textAlign: { xs: 'center', md: 'start' },
                fontWeight: { xs: 400, md: 700 },
              }}
            >
              Includes logos, photos, product images and more
            </Typography>
          </Stack>

          <Button
            component="a"
            href="https://drive.google.com/drive/folders/1rju5Dxw5ocrI4xRRA_kB0J4z2azh2xzY"
            target="_blank"
            rel="noreferrer noopener"
            variant="contained"
            sx={{
              paddingX: theme.spacing(9),
              width: { xs: '100%', md: 'fit-content' },
            }}
          >
            Download Media Kit
          </Button>
        </Stack>
      </ContentStack>
    </BackgroundStack>
  );
}

export default OneVillageMediaKit;
